/**
 * Extract a flat `field -> first message` map from a Laravel-style validation
 * error response. Returns an empty object when the error has no `errors` map.
 */
export function getApiFieldErrors(error: unknown): Record<string, string> {
  if (!error || typeof error !== 'object' || !('data' in error)) return {};

  const data = (error as { data?: { errors?: Record<string, string[] | string> } }).data;
  if (!data?.errors || typeof data.errors !== 'object' || Array.isArray(data.errors)) return {};

  const map: Record<string, string> = {};
  for (const [field, messages] of Object.entries(data.errors)) {
    if (Array.isArray(messages) && messages.length > 0) {
      map[field] = String(messages[0]);
    } else if (typeof messages === 'string' && messages.trim()) {
      map[field] = messages.trim();
    }
  }
  return map;
}
